import * as Sentry from '@sentry/react'

let enabled = false

/**
 * Initialize browser Sentry when VITE_SENTRY_DSN is set at build time.
 */
export function initSentry() {
  const dsn = String(import.meta.env.VITE_SENTRY_DSN || '').trim()
  if (!dsn) return false
  if (enabled) return true

  const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1')
  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || 'development',
    release: import.meta.env.VITE_BUILD_SHA || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0.1,
  })
  enabled = true
  return true
}

export function captureException(error, context = {}) {
  if (!enabled) return
  Sentry.withScope((scope) => {
    Object.entries(context).forEach(([key, value]) => {
      if (value != null) scope.setExtra(key, value)
    })
    Sentry.captureException(error)
  })
}

export { Sentry }
